import { Directive, ElementRef, Input, HostListener } from "@angular/core"; 

@Directive({
    selector: 'input[NumberOnly]'
})
export class NumberOnlyDirective {
 

    constructor(private ele: ElementRef) {

    }

    @HostListener('input', ['$event']) onInputChange(event) {
        const initalValue = this.ele.nativeElement.value;
         
        this.ele.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
        if ( initalValue !== this.ele.nativeElement.value) {
          event.stopPropagation();
        }
      }


}